module.exports = __webpack_public_path__ + "img/ANTENNA 4 GREEN.3a2ddfa.svg";